(() => {
  document.querySelectorAll('[data-ss-pi]').forEach((root) => {
    const tabs = [...root.querySelectorAll('[data-ss-tab]')];
    const panels = [...root.querySelectorAll('[data-ss-panel]')];

    const activate = (tab, focus = false) => {
      if (!tab) return;
      const key = tab.dataset.ssTab;
      tabs.forEach((item) => {
        const active = item === tab;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', active ? 'true' : 'false');
        item.tabIndex = active ? 0 : -1;
      });
      panels.forEach((panel) => {
        panel.hidden = panel.dataset.ssPanel !== key;
      });

      if (window.matchMedia('(max-width: 749px)').matches) {
        const tablist = tab.closest('.ss-pi__tabs');
        if (tablist) {
          const listRect = tablist.getBoundingClientRect();
          const tabRect = tab.getBoundingClientRect();
          if (tabRect.right > listRect.right - 12) {
            tablist.scrollBy({ left: tabRect.right - listRect.right + 12, behavior: 'smooth' });
          } else if (tabRect.left < listRect.left) {
            tablist.scrollBy({ left: tabRect.left - listRect.left - 12, behavior: 'smooth' });
          }
        }
      }

      if (focus) tab.focus();
    };

    tabs.forEach((tab, index) => {
      tab.tabIndex = tab.classList.contains('is-active') ? 0 : -1;
      tab.addEventListener('click', () => activate(tab));
      tab.addEventListener('keydown', (event) => {
        let nextIndex = null;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        if (nextIndex !== null) {
          event.preventDefault();
          activate(tabs[nextIndex], true);
        }
      });
    });

    root.querySelectorAll('[data-ss-readmore]').forEach((box) => {
      if (box.dataset.ssReadmoreReady === 'true') return;
      box.dataset.ssReadmoreReady = 'true';

      const content = box.querySelector('[data-ss-readmore-content]');
      const moreButton = box.querySelector('[data-ss-readmore-toggle]');
      if (!content || !moreButton) return;

      const firstParagraph = [...content.querySelectorAll('p')].find(
        (paragraph) => paragraph.textContent.trim() !== ''
      );
      if (!firstParagraph) return;

      const range = document.createRange();
      range.setStartAfter(firstParagraph);
      range.setEnd(content, content.childNodes.length);
      const remainder = range.extractContents();

      const extra = document.createElement('div');
      extra.className = 'ss-pi__readmore-extra rte';
      extra.appendChild(remainder);

      const hasMeaningfulExtra =
        extra.textContent.trim() !== '' ||
        extra.querySelector('img, video, iframe, ul, ol, table, blockquote');
      if (!hasMeaningfulExtra) return;

      const lessButton = document.createElement('button');
      lessButton.type = 'button';
      lessButton.className = 'ss-pi__more ss-pi__less';
      lessButton.textContent = 'Minder lezen';
      lessButton.setAttribute('aria-expanded', 'true');
      lessButton.hidden = true;

      moreButton.textContent = 'Meer lezen';
      moreButton.setAttribute('aria-expanded', 'false');
      moreButton.hidden = false;

      moreButton.insertAdjacentElement('afterend', extra);
      extra.insertAdjacentElement('afterend', lessButton);
      extra.hidden = true;

      moreButton.addEventListener('click', () => {
        moreButton.hidden = true;
        extra.hidden = false;
        lessButton.hidden = false;
        moreButton.setAttribute('aria-expanded', 'true');
      });

      lessButton.addEventListener('click', () => {
        extra.hidden = true;
        lessButton.hidden = true;
        moreButton.hidden = false;
        moreButton.setAttribute('aria-expanded', 'false');
        moreButton.focus({ preventScroll: true });
      });
    });
  });
})();
